import React from 'react'
import { Card, Space, Typography } from 'antd'
import { amountToCurrencyFormat } from '../../../../utils/format'
import { ISubscriptionTypeExtended, SubscriptionType } from '../../../../context/types'
import { CheckCircleFilled } from '@ant-design/icons'

const { Title, Paragraph } = Typography

export type SubscriptionCardProps = {
	data: SubscriptionType | ISubscriptionTypeExtended
	bottomCaption: React.ReactNode
	current?: boolean
	actions?: React.ReactNode[]
	bottomAction?: React.ReactNode
}

export const SubscriptionCard = ({ actions, data, bottomCaption, bottomAction, current }: SubscriptionCardProps) => {
	return (
		<Card
			actions={actions}
			headStyle={{ borderBottom: 'none' }}
			className={current ? 'current-subscription' : ''}
			bordered={false}
			title={
				<>
					<Title className="subscription-title" level={3}>
						{data.name}{' '}
						{!!current && (
							<span className="subscription-current-plan-caption">
								<CheckCircleFilled />
								Your plan
							</span>
						)}
					</Title>
					<Title className="subscription-title subscription-price" level={2}>
						{!data.price_per_month ? 'from ' + data.channel?.name : '$' + amountToCurrencyFormat(data.price_per_month)}
					</Title>
				</>
			}
		>
			<Space direction="vertical">
				<Paragraph style={{ minHeight: 100 }}>{data.description}</Paragraph>

				<Paragraph>{bottomCaption}</Paragraph>

				{!!bottomAction && <div className="subscription-bottom-action">{bottomAction}</div>}
			</Space>
		</Card>
	)
}
